export const jotFormKeys = {
    form: (id: string) => ["jot-form", id],
};
